import React, { useState } from "react";
import { auth, db } from "./firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "./signin.css";
import { FiEye, FiEyeOff } from "react-icons/fi";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const login = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const userId = userCredential.user.uid;

      const userDoc = await getDoc(doc(db, "users", userId));
      if (userDoc.exists()) {
        const { role } = userDoc.data();
        if (role === "admin") {
          navigate("/main-panel");
        } else if (role === "corporate") {
          navigate("/corporate");
        } else {
          alert("Role not recognized. Contact admin.");
        }
      } else {
        alert("No user data found. Please contact admin.");
      }
    } catch (error) {
      console.error("Error logging in:", error.message);
      alert(error.message);
    }
  };

  const navigateToForgotPassword = () => {
    navigate("/ForgotPassword");
  };

  return (
    <div className="vi-split-container">
      {/* Left Half - GIF Section */}
      <div className="vi-visual-section">
        <div className="vi-gif-container">
          <img
            src="login.gif"
            alt="Animation demonstrating accessibility features"
            className="vi-walking-gif"
          />
        </div>
        <div className="vi-visual-description">
          <h2>Reaching To Unreach</h2>
          <p>Visual Impairment Support System</p>
        </div>
      </div>

      {/* Right Half - Login Form */}
      <div className="vi-form-section">
        <div className="vi-signin-container">
          <h1 className="vi-signin-title">Login Panel</h1>
          
          <form onSubmit={login} className="vi-signin-form">
            <div className="vi-input-group">
              <label htmlFor="email" className="vi-signin-label">Email Address</label>
              <div className="vi-input-wrapper">
                <input
                  id="email"
                  type="email"
                  className="vi-signin-input"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  aria-required="true"
                />
              </div>
            </div>

            <div className="vi-input-group">
              <label htmlFor="password" className="vi-signin-label">Password</label>
              <div className="vi-input-wrapper">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  className="vi-signin-input"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  aria-required="true"
                />
                <button
                  type="button"
                  className="vi-password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                </button>
              </div>
            </div>

            <div className="vi-form-actions">
              <button type="submit" className="vi-signin-button">
                Login
              </button>
              
              <button
                type="button"
                className="vi-forgot-password"
                onClick={navigateToForgotPassword}
              >
                Forgot Password?
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignIn;